import React from "react";
import { FiArrowRight } from "react-icons/fi";
import { METHODS } from "../../../utils/data";

function SelectPaymentMethod({ setTransactionType }) {
  return (
    <section aria-labelledby="withdraw-method-title">
      <div className="pg-withdraw-method-heading"><span className="pg-finance-eyebrow">PAYOUT METHOD</span><h2 id="withdraw-method-title">Where should we send it?</h2><p>Select the destination type for this withdrawal request.</p></div>
      <div className="pg-withdraw-method-list">
        {METHODS.filter((item) => item.name !== "Gcash").map((item) => (
          <button type="button" onClick={() => setTransactionType(item.name)} key={item.name} className="pg-withdraw-method-option">
            <span className="pg-withdraw-method-copy"><span className="pg-withdraw-method-icon"><img src={item.icon} alt="" /></span><span className="pg-withdraw-method-text"><strong>{item.name}</strong><small>{item.description}</small></span></span><FiArrowRight size={16} aria-hidden="true" />
          </button>
        ))}
      </div>
    </section>
  );
}

export default SelectPaymentMethod;
